import { useSelector } from './use-selector.js';
import { MeterBarChartTooltipState } from '../../types/state.js';

export const useTooltipState = () =>
  useSelector((state: MeterBarChartTooltipState) => state);

export const useTooltipPosition = () =>
  useSelector((state: MeterBarChartTooltipState) => state.position);

export const useTooltipPinned = () =>
  useSelector((state: MeterBarChartTooltipState) => state.pinned);

export const useTooltipVisible = () =>
  useSelector((state: MeterBarChartTooltipState) => state.visible);
